module.exports = __webpack_public_path__ + "static/media/chengxingou.a162c792.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/staticPage/regular/chengxingou.jpg
// module id = 478
// module chunks = 0